import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DividerModule } from '../divider/divider.module';
import { AppFlexModule } from '../flex/index.js';
import { TagModule } from '../tag/index.js';
import { TooltipModule } from '../tooltip/tooltip.module.js';
import { NutritionBoxesComponent } from './nutrition-boxes.component.js';

@NgModule({
	imports: [CommonModule, AppFlexModule, TagModule, TooltipModule, DividerModule],
	declarations: [NutritionBoxesComponent],
	exports: [NutritionBoxesComponent]
})
export class NutritionModule {}
